import {defineStore} from "pinia";
import axios from "axios";

export const useAppProductRequest = defineStore("appProductRequest", {
	state: () => {
    return {
      dialog: false,
      loading: false,

      mainImageIdx: null,
      title: '',
      linkExternal: "",
      linkType: 'I', // I - 내부, O - 외부
      isOpen: 'Y',   // Y - 공개, N - 비공개
      image: null,
      thumbnail: '',
      gubun: 'P',    // 이미지 타입. P - 팝업, S - 슬라이드
      contentList: [],
      search:{
        gubun: 'P',   // 'P' : 팝업(default), 'S' : 슬라이드
        prop: 'id'    // 정렬 기준, 'id' : 아이디 및 생성순서(default), 'update' : 수정된 순서
      }
    }
  },

	// computed
  getters: {
		/*
		setTodayContents: (state) => (content) => {
      state.todayContentIdx = content.todayContentIdx;
      state.wdate = content.wdate;
      state.title = content.title;
      state.contents = content.contents;
      state.questions = content.questions;
      state.explanation = content.explanation;
      state.thumbnail = `http://118.67.134.110:18080/${content.thumbnailImageLink}`
    },
		 */

  },

	actions: {
		/*
		async getTodayContentsList() {
      // const url = `/api/app/today-content/list?page=1&size=10&startDate=2024-01-01&endDate=2024-01-03`;
      const url = `/api/app/today-content/list?page=${this.page}&size=${this.size}`;
      const { data, status } = await axios.get(url);
      if (status === 200) {
        if (data.code === "200") {
          this.setTodayContentsList(data.data.todayContentList);
        } else {
          return {
            code: res.data.code,
            message: res.data.message
          };
        }
      }
    },
		 */

	}
})